// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img-icons {
    display: none;
    flex-direction: row;
    padding: 0 5px;
    justify-content: space-around;
    align-items: center;
    border-radius: var(--radius-small);
    background-color: var(--surface-variant-dark-transparency);
    margin: 3px 3px 0px 0px;
    width: 45px;
}

.img-icons md-icon {
    font-size: calc(1em + 1vw);
    justify-content: center;
    align-items: center;
    margin-block-start: 1px;
    color: var(--on-primary-container);
}

.img-icons > *:not(p) {
    --md-icon-size: 30px;
    color: var(--on-primary-container);
    flex: 1;
    width: var(--md-icon-size);
    max-width: var(--md-icon-size);
    height: var(--md-icon-size);
    aspect-ratio: 1 / 1;
    border-radius: var(--radius-extra-small);
    background-color: var(--surface-variant-dark-transparency);
    justify-content: center;
    align-items: center;
    padding: 6px;
}

.img-icons > *:not(p):hover {
    background-color: var(--surface-variant-transparency);
    color: #fff;
    transition: background-color 0.5s ease-in-out color 0.5s ease-in-out;
    cursor: pointer;
}

.img-icons-inside-card {
    position: absolute;
    top: 0;
    right: 0;
}

.img-icons-outside-card {
    width: fit-content;
    background-color: transparent;
    gap: 10px;
    margin-block-start: 5px;
}

.img-icons-outside-card > * {
    border-radius: var(--radius-small);
    background-color: var(--outline);
    box-shadow: var(--elevation-1);
}

.img-icons-outside-card > *:hover {
    background-color: var(--surface-variant-transparency);
    transition: background-color 0.5s ease-in-out color 0.5s ease-in-out;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/image-icons.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,6BAA6B;IAC7B,mBAAmB;IACnB,kCAAkC;IAClC,0DAA0D;IAC1D,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,kCAAkC;IAClC,OAAO;IACP,0BAA0B;IAC1B,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;IACnB,wCAAwC;IACxC,0DAA0D;IAC1D,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,qDAAqD;IACrD,WAAW;IACX,oEAAoE;IACpE,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,qDAAqD;IACrD,oEAAoE;IACpE,eAAe;AACnB","sourcesContent":[".img-icons {\n    display: none;\n    flex-direction: row;\n    padding: 0 5px;\n    justify-content: space-around;\n    align-items: center;\n    border-radius: var(--radius-small);\n    background-color: var(--surface-variant-dark-transparency);\n    margin: 3px 3px 0px 0px;\n    width: 45px;\n}\n\n.img-icons md-icon {\n    font-size: calc(1em + 1vw);\n    justify-content: center;\n    align-items: center;\n    margin-block-start: 1px;\n    color: var(--on-primary-container);\n}\n\n.img-icons > *:not(p) {\n    --md-icon-size: 30px;\n    color: var(--on-primary-container);\n    flex: 1;\n    width: var(--md-icon-size);\n    max-width: var(--md-icon-size);\n    height: var(--md-icon-size);\n    aspect-ratio: 1 / 1;\n    border-radius: var(--radius-extra-small);\n    background-color: var(--surface-variant-dark-transparency);\n    justify-content: center;\n    align-items: center;\n    padding: 6px;\n}\n\n.img-icons > *:not(p):hover {\n    background-color: var(--surface-variant-transparency);\n    color: #fff;\n    transition: background-color 0.5s ease-in-out color 0.5s ease-in-out;\n    cursor: pointer;\n}\n\n.img-icons-inside-card {\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n\n.img-icons-outside-card {\n    width: fit-content;\n    background-color: transparent;\n    gap: 10px;\n    margin-block-start: 5px;\n}\n\n.img-icons-outside-card > * {\n    border-radius: var(--radius-small);\n    background-color: var(--outline);\n    box-shadow: var(--elevation-1);\n}\n\n.img-icons-outside-card > *:hover {\n    background-color: var(--surface-variant-transparency);\n    transition: background-color 0.5s ease-in-out color 0.5s ease-in-out;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
